import styled from 'styled-components';
import { key } from 'styled-theme';
import { media } from '@sizeid/commons/utils/styles';

export default styled.div`
  position: relative;

  ${media.moreThan('companyHistoryPlus')`
    margin-left: 175px;
    padding-left: 45px;
    border-left: 2px solid ${key('colors.black.light.300')};
  `};
`;
